import { graphql } from "gql.tada";
import { LinkFragment } from "./LinkFragment";

export const CaseStudyCardSectionFragment = graphql(
  `
    fragment CaseStudyCardSectionFragment on CaseStudyCardSection {
      sys {
        id
      }
      internalLabel
      caseStudyCardsCollection(limit: 20) {
        items {
          sys {
            id
          }
          headline
          posterImage {
            url
            contentType
            title
          }
          partnerLogosCollection(limit: 10) {
            items {
              url
              contentType
              title
            }
          }
          tagsCollection(limit: 20) {
            items {
              sys {
                id
              }
              tagLabel
            }
          }
          ctaLink {
            ...LinkFragment
          }
        }
      }
    }
  `,
  [LinkFragment]
);
